/**
 * The numbers billing runs on, from `saas-billing.spec.md`. One place, so the
 * API's deadlines, the web's countdowns and the emails can never disagree.
 */

/** $10 per active venue per month, in cents. */
export const PRICE_PER_VENUE_CENTS = 1000

/** A new company's free trial. Card required; charged when it ends. */
export const TRIAL_DAYS = 14

/** Full access after a failed payment before the company is locked. */
export const GRACE_DAYS = 14

/** Full access after a super admin ends a comp, for the owner to subscribe. */
export const COMP_NOTICE_DAYS = 14

/** The most a super admin may add to one trial, or one grace period, in total. */
export const MAX_EXTENSION_DAYS = 14

/** How long a company canceled during its trial stays, locked, before it is deleted. */
export const TRIAL_CANCELLED_RETENTION_DAYS = 30

/** How long an unfinished signup is kept before it is purged. */
export const SIGNUP_INCOMPLETE_RETENTION_DAYS = 30

/** How many days before the trial ends the reminder email goes out. */
export const TRIAL_ENDING_NOTICE_DAYS = 3

/**
 * Whether billing has gone live: Stripe is set up in this environment and every
 * company has a billing owner (see DEPLOY_NOTES.md). **Off until then**, and
 * while off, nothing can put a company where only paying gets it out:
 *
 * - a super admin cannot create a company as paid, or end a comp — either would
 *   lock a company that has no way to pay;
 * - the customer-facing Billing page and its nav entry are hidden;
 * - the hourly cleanup and billing emails stay idle.
 *
 * What a super admin needs to get ready — choosing billing owners, seeing each
 * company's state, comping — works regardless. Turn it on in the change that
 * follows Stripe's setup.
 */
export const BILLING_LIVE = false
